import { render, staticRenderFns } from "./carHold.vue?vue&type=template&id=990c82a4&scoped=true"
import script from "./carHold.vue?vue&type=script&lang=js"
export * from "./carHold.vue?vue&type=script&lang=js"
import style0 from "./carHold.vue?vue&type=style&index=0&id=990c82a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990c82a4",
  null
  
)

export default component.exports